export class PaymentUpsellError extends Error {
  constructor() {
    super('Upsell is already active');
  }
}
